import React, { useCallback } from 'react';
import { claims as claimsSelection } from '@zipdrug/react-api-sdk';
import { alertOnError } from '@zipdrug/ui';
import { graphql } from '@apollo/client/react/hoc';
import { get, uniq } from 'lodash';
import gql from 'graphql-tag';
import fetchOnceOptions from 'hoc/utils/fetchOnceOptions';
import RxItem from './RxItem';

function RxItemContainer(props) {
  const { isActive, mutateUpdateClaims, rxClaims, ...rest } = props;

  const onToggleActiveStatus = useCallback(() => {
    if (!rxClaims) return;
    const { ndc_code, patient_id } = rxClaims[0];
    alertOnError(
      mutateUpdateClaims({
        variables: {
          modifier: {
            is_active: !isActive,
          },
          ndc_code: Number.parseFloat(ndc_code),
          patient_id,
        },
      }),
    );
  }, [isActive, mutateUpdateClaims, rxClaims]);

  return (
    <RxItem
      {...rest}
      isActive={isActive}
      rxClaims={rxClaims}
      onToggleActiveStatus={onToggleActiveStatus}
    />
  );
}

const withMutateUpdateClaims = graphql(claimsSelection.mutateUpdateClaims, {
  name: 'mutateUpdateClaims',
});
const withPostalCodesByPharmacies = graphql(
  gql`
    query postalCodeCoverageByPharmacies($ids: [Int]!) {
      postalCodeCoverageByPharmacies(ids: $ids) {
        data {
          id
          hasPostalCodes
        }
      }
    }
  `,
  {
    options: ({ allClaims }) => {
      const pharmacyArray = uniq(allClaims?.map(c => c.pharmacy.id));
      return fetchOnceOptions('postalCodeCoverageByPharmacies', {
        variables: {
          ids: pharmacyArray,
        },
      });
    },
    props: ({ data: { postalCodeCoverageByPharmacies: result } }) => ({
      postalCodesByPharmacies: get(result, 'data'),
    }),
  },
);

export default withMutateUpdateClaims(withPostalCodesByPharmacies(RxItemContainer));
